@if (canManageKycReview()) {
  <div class="notification-bell">
    <button
      type="button"
      class="notification-bell__trigger"
      [attr.aria-label]="'notifications.bell.ariaLabel' | transloco"
      [attr.aria-expanded]="isOpen()"
      (click)="togglePanel()"
    >
      <i class="fas fa-bell"></i>
      @if (notificationStore.unreadCount() > 0) {
        <span class="notification-bell__badge">{{ notificationStore.unreadCount() }}</span>
      }
    </button>

    @if (isOpen()) {
      <div class="notification-bell__panel" role="dialog" aria-live="polite">
        <div class="notification-bell__header">
          {{ 'notifications.bell.title' | transloco }}
        </div>

        @if (notificationStore.notifications().length === 0) {
          <div class="notification-bell__empty">
            {{ 'notifications.bell.empty' | transloco }}
          </div>
        } @else {
          @for (notification of notificationStore.notifications(); track notification.id) {
            <div
              class="notification-bell__item notification-bell__item--{{ notification.severity }}"
            >
              <span class="notification-bell__item-icon" aria-hidden="true">{{
                notification.icon
              }}</span>
              <div class="notification-bell__item-body">
                <strong class="notification-bell__item-title">{{
                  notification.titleKey | transloco
                }}</strong>
                <span class="notification-bell__item-text">{{
                  notification.textKey | transloco
                }}</span>
                @if (notification.buttonTextKey) {
                  <button
                    type="button"
                    class="notification-bell__item-action"
                    (click)="onActionClicked()"
                  >
                    {{ notification.buttonTextKey | transloco }}
                  </button>
                }
              </div>
            </div>
          }
        }
      </div>
    }
  </div>
}
